import React, { useState, useEffect } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import PropTypes from "prop-types";

// Settings Component
const ChamailleonSettings = ({ onSave, isOpen, onClose }) => {
  const [settings, setSettings] = useState({
    apiKey: '',
    splashScreenUrl: 'https://chamaileon-sdk.github.io/splashscreen-and-logo-examples/splashScreen.html',
    createLogoJsUrl: 'https://chamaileon-sdk.github.io/splashscreen-and-logo-examples/createLogo.js',
    primaryColor: '#2D3291'
  });

  useEffect(() => {
    const savedSettings = localStorage.getItem('chamaileonSdkDemoSettings');
    if (savedSettings) {
      setSettings(JSON.parse(savedSettings));
    }
  }, []);

  const handleSave = () => {
    localStorage.setItem('chamaileonSdkDemoSettings', JSON.stringify(settings));
    onSave(settings);
  };

  if (!isOpen) return null;

  return (
    <Card className="settings-panel">
      <Card.Header>
        <h3>Chamaileon SDK Settings</h3>
      </Card.Header>
      <Card.Body>
        
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>API Key</Form.Label>
            <Form.Control
              type="text"
              value={settings.apiKey}
              onChange={(e) => setSettings({...settings, apiKey: e.target.value})}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Splash Screen URL</Form.Label>
            <Form.Control
              type="text"
              value={settings.splashScreenUrl}
              onChange={(e) => setSettings({...settings, splashScreenUrl: e.target.value})}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Create Logo JS URL</Form.Label>
            <Form.Control
              type="text"
              value={settings.createLogoJsUrl}
              onChange={(e) => setSettings({...settings, createLogoJsUrl: e.target.value})}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Primary Color</Form.Label>
            <Form.Control
              type="color"
              value={settings.primaryColor}
              onChange={(e) => setSettings({...settings, primaryColor: e.target.value})}
            />
          </Form.Group>

          <Button variant="primary" onClick={handleSave}>Save Settings</Button>
          <Button variant="secondary" className="ms-2" onClick={onClose}>Cancel</Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

ChamailleonSettings.propTypes = {
  onSave : PropTypes.func, 
  isOpen : PropTypes.bool,
  onClose : PropTypes.func,
}

export default ChamailleonSettings;